import React, { Fragment } from 'react'
import { Paper, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux'
import {
    actualizarFC_34Estatus,
    agregarMapFC_34Accion,
    obtenerIdCliente, guardarCambiosFC_34Solicitud,
    actualizarFC_34MapSolicitud, actualizarFC_34Solicitud,
    resetDataFC_34, generarDocumentosFC_34, obtenerFC_34SolicitudDetalle,
    actualizarFC_34SolicitudModal
} from '../../../redux/DucksAtencionACliente/FC_34AtencionAClienteDucks'
import { AcualizarFormatoAccion } from '../../../redux/DucksAtencionACliente/AtencionAClienteDucks'
import { actualizarLoadingApp_true, actualizarLoadingApp_false } from '../../../redux/AppDucks'
import { useStateIfMounted } from 'use-state-if-mounted'
import { withRouter } from 'react-router-dom'
import moment from 'moment'
import SaveIcon from '@mui/icons-material/Save';
import IconButton from '@mui/material/IconButton';
import FormatClearIcon from '@mui/icons-material/FormatClear';
import ToolBarPaginas from '../../App/ToolBarPaginas';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import PaginacionAtencionAClientesComponent from '../../App/PaginacionAtencionAClientesComponent';
import TablaAtencionACliente from '../../App/TablaAtencionACliente';
import { obtenerTodasLasSolicitudesEjecuctivoWithStatusEnviado } from '../../../redux/DucksAtencionACliente/AtencionAClienteDucks';
import { obtenerTodasLasSolicitudesWithStatusEnviado } from '../../../redux/AtencionAClienteDucks'
import TablaDocumentacion from '../../App/TablaDocumentacion';
import { obtenerClienteByIdLogin } from '../../../redux/DucksBeneficiario/ClienteDucks';
import estilosFC34 from './AtencionAClientesFC_34Component.module.css'; { {/*Estilos para el componente*/ } }
import { v4 as uuidv4 } from 'uuid';
import FormularioDocumentacionFC_34 from './FormularioDocumentacionFC_34';
import { crearMetricas } from '../../../redux/DuckMetricas/MetricasDuck';

const { useState, useEffect, useRef } = React;
const styleParaModalDeDocumentos = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 1000,
    height: 600,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    color: 'black',
    p: 4,
    'overflowY': 'scroll',
};
const styleDevolver = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};
function FC_34Component(props) {
    const dispatch = useDispatch()

    const formato = useSelector(store => store.AtencionSolicitud.formato)
    const tipoUsuario = useSelector(store => store.Usuario.tipoUsuario)

    const usuario = useSelector(store => store.Usuario)
    let fc_34 = useSelector(store => store.FC_34SolicitudAtencionACliente.fc_34)
    let modoEdicionBorrador = useSelector(store => store.FC_34SolicitudAtencionACliente.modoEdicionBorrador)
    let solicitud = useSelector(store => store.FC_34SolicitudAtencionACliente.data)
    let fc_34Map = useSelector(store => store.FC_34SolicitudAtencionACliente.fc_34Map)
    const modoVerDetalle = useSelector(store => store.FC_34SolicitudAtencionACliente.modoVerDetalle)
    const currentUser = useSelector(store => store.Usuario.data)
    const dataUser = useSelector(store => store.Usuario.user)

    var fechaHoy = moment().format('YYYY-MM-DD');

    const [paginas, setPaginas] = useStateIfMounted([1, 2])
    const [paginaActiva, setPaginaActiva] = useStateIfMounted(1)
    const [nombresParaPaginas, setNombresParaPaginas] = useStateIfMounted(['Datos solicitante', 'Suspención/Reactivación'])
    const cambiarPagina = (pagina) => {
        setPaginaActiva(pagina)
    }
    let pagina1 = []
    let tipo = solicitud.tipoinstalacion?.split('/')
    let tipoInstalacion = ''
    if (tipo?.[0] == '1') tipoInstalacion = 'Unidad de producción'
    if (tipo?.[0] == '2') tipoInstalacion = 'Unidad de envasado'
    if (tipo?.[0] == '3') tipoInstalacion = 'Unidad de almacén'
    pagina1.push(
        {
            id: uuidv4(), Campo: 'Tipo de instalación', valor: tipoInstalacion, idfc34_notificacionsuspencion: solicitud.idfc34_notificacionsuspencion,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_34Map) && JSON.stringify([]) !== JSON.stringify(fc_34Map) ? fc_34Map?.tipoinstalacion : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_34Map) && JSON.stringify([]) !== JSON.stringify(fc_34Map) ? !fc_34Map?.tipoinstalacioncheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_34Map) && JSON.stringify([]) !== JSON.stringify(fc_34Map) ? fc_34Map?.tipoinstalacioncheck : false,
        },
        {
            id: uuidv4(), Campo: 'Nombre de responsable', valor: solicitud.responsableinstalaciones, idfc34_notificacionsuspencion: solicitud.idfc34_notificacionsuspencion,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_34Map) && JSON.stringify([]) !== JSON.stringify(fc_34Map) ? fc_34Map?.responsableinstalaciones : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_34Map) && JSON.stringify([]) !== JSON.stringify(fc_34Map) ? !fc_34Map?.responsableinstalacionescheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_34Map) && JSON.stringify([]) !== JSON.stringify(fc_34Map) ? fc_34Map?.responsableinstalacionescheck : false,
        },
        {
            id: uuidv4(), Campo: 'Correo Electrónico', valor: solicitud.correoelectronico, idfc34_notificacionsuspencion: solicitud.idfc34_notificacionsuspencion,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_34Map) && JSON.stringify([]) !== JSON.stringify(fc_34Map) ? fc_34Map?.correoelectronico : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_34Map) && JSON.stringify([]) !== JSON.stringify(fc_34Map) ? !fc_34Map?.correoelectronicocheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_34Map) && JSON.stringify([]) !== JSON.stringify(fc_34Map) ? fc_34Map?.correoelectronicocheck : false,
        },
        {
            id: uuidv4(), Campo: 'Teléfono', valor: solicitud.telefono, idfc34_notificacionsuspencion: solicitud.idfc34_notificacionsuspencion,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_34Map) && JSON.stringify([]) !== JSON.stringify(fc_34Map) ? fc_34Map?.telefono : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_34Map) && JSON.stringify([]) !== JSON.stringify(fc_34Map) ? !fc_34Map?.telefonocheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_34Map) && JSON.stringify([]) !== JSON.stringify(fc_34Map) ? fc_34Map?.telefonocheck : false,
        },
        {
            id: uuidv4(), Campo: 'Domicilio Completo', valor: solicitud.domicilio, idfc34_notificacionsuspencion: solicitud.idfc34_notificacionsuspencion,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_34Map) && JSON.stringify([]) !== JSON.stringify(fc_34Map) ? fc_34Map?.domicilio : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_34Map) && JSON.stringify([]) !== JSON.stringify(fc_34Map) ? !fc_34Map?.domiciliocheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_34Map) && JSON.stringify([]) !== JSON.stringify(fc_34Map) ? fc_34Map?.domiciliocheck : false,
        },
    )
    if (solicitud.servicioinstalacion == 'produccion' || solicitud.servicioinstalacion == 'envasado' || solicitud.servicioinstalacion == 'almacen') pagina1.push({
        id: uuidv4(), Campo: 'Servicio de instalación a notificar: ', valor: solicitud.servicioinstalacion == 'produccion' ? 'Producción' : solicitud.servicioinstalacion == 'envasado' ? 'Envasado' : solicitud.servicioinstalacion == 'almacen' ? 'Almacén' : '', idfc34_notificacionsuspencion: solicitud.idfc34_notificacionsuspencion,
        observaciones: JSON.stringify({}) !== JSON.stringify(fc_34Map) && JSON.stringify([]) !== JSON.stringify(fc_34Map) ? fc_34Map?.servicioinstalacion : '',
        correcto: JSON.stringify({}) !== JSON.stringify(fc_34Map) && JSON.stringify([]) !== JSON.stringify(fc_34Map) ? !fc_34Map?.servicioinstalacioncheck : false,
        incorrecto: JSON.stringify({}) !== JSON.stringify(fc_34Map) && JSON.stringify([]) !== JSON.stringify(fc_34Map) ? fc_34Map?.servicioinstalacioncheck : false,
    })
    if (solicitud.servicioactividad == 'reactivacion' || solicitud.servicioactividad == 'suspension') pagina1.push({
        id: uuidv4(), Campo: 'Servicio de actividad a notificar: ', valor: solicitud.servicioactividad == 'reactivacion' ? 'Reactivación' : 'Suspensión', idfc34_notificacionsuspencion: solicitud.idfc34_notificacionsuspencion,
        observaciones: JSON.stringify({}) !== JSON.stringify(fc_34Map) && JSON.stringify([]) !== JSON.stringify(fc_34Map) ? fc_34Map?.servicioactividad : '',
        correcto: JSON.stringify({}) !== JSON.stringify(fc_34Map) && JSON.stringify([]) !== JSON.stringify(fc_34Map) ? !fc_34Map?.servicioactividadcheck : false,
        incorrecto: JSON.stringify({}) !== JSON.stringify(fc_34Map) && JSON.stringify([]) !== JSON.stringify(fc_34Map) ? fc_34Map?.servicioactividadcheck : false,
    })
    if (solicitud.servicioinstalacion == 'produccion') pagina1.push(
        {
            id: uuidv4(), Campo: 'Certificado NOM de productor', valor: solicitud.certificadonomproductor ? 'Si' : 'No', idfc34_notificacionsuspencion: solicitud.idfc34_notificacionsuspencion,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_34Map) && JSON.stringify([]) !== JSON.stringify(fc_34Map) ? fc_34Map?.certificadonomproductor : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_34Map) && JSON.stringify([]) !== JSON.stringify(fc_34Map) ? !fc_34Map?.certificadonomproductorcheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_34Map) && JSON.stringify([]) !== JSON.stringify(fc_34Map) ? fc_34Map?.certificadonomproductorcheck : false,
        },
    )
    if (solicitud.servicioinstalacion == 'envasado') pagina1.push(
        {
            id: uuidv4(), Campo: 'Certificado NOM de comercializador', valor: solicitud.certificadonomcomercializador ? 'Si' : 'No', idfc34_notificacionsuspencion: solicitud.idfc34_notificacionsuspencion,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_34Map) && JSON.stringify([]) !== JSON.stringify(fc_34Map) ? fc_34Map?.certificadonomcomercializador : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_34Map) && JSON.stringify([]) !== JSON.stringify(fc_34Map) ? !fc_34Map?.certificadonomcomercializadorcheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_34Map) && JSON.stringify([]) !== JSON.stringify(fc_34Map) ? fc_34Map?.certificadonomcomercializadorcheck : false,
        })
    let [rowspagina1, setRowsPagina1] = React.useState(pagina1)


    let pagina2 = []
    if (solicitud.servicioactividad == 'suspension') pagina2.push({
        id: uuidv4(), Campo: 'Motivo de la suspensión', valor: solicitud.motivosuspencion, idfc34_notificacionsuspencion: solicitud.idfc34_notificacionsuspencion,
        observaciones: JSON.stringify({}) !== JSON.stringify(fc_34Map) && JSON.stringify([]) !== JSON.stringify(fc_34Map) ? fc_34Map?.motivosuspencion : '',
        correcto: JSON.stringify({}) !== JSON.stringify(fc_34Map) && JSON.stringify([]) !== JSON.stringify(fc_34Map) ? !fc_34Map?.motivosuspencioncheck : false,
        incorrecto: JSON.stringify({}) !== JSON.stringify(fc_34Map) && JSON.stringify([]) !== JSON.stringify(fc_34Map) ? fc_34Map?.motivosuspencioncheck : false,
    })
    if (solicitud.servicioactividad == 'reactivacion' && (solicitud.servicioinstalacion == 'envasado' || solicitud.servicioinstalacion == 'almacen')) pagina2.push({
        id: uuidv4(), Campo: 'Información de la reactivación', valor: solicitud.informacionadicional, idfc34_notificacionsuspencion: solicitud.idfc34_notificacionsuspencion,
        observaciones: JSON.stringify({}) !== JSON.stringify(fc_34Map) && JSON.stringify([]) !== JSON.stringify(fc_34Map) ? fc_34Map?.motivosuspencion : '',
        correcto: JSON.stringify({}) !== JSON.stringify(fc_34Map) && JSON.stringify([]) !== JSON.stringify(fc_34Map) ? !fc_34Map?.motivosuspencioncheck : false,
        incorrecto: JSON.stringify({}) !== JSON.stringify(fc_34Map) && JSON.stringify([]) !== JSON.stringify(fc_34Map) ? fc_34Map?.motivosuspencioncheck : false,
    })
    if (solicitud.servicioinstalacion == 'produccion' && solicitud.servicioactividad == 'reactivacion') pagina2.push({
        id: uuidv4(), Campo: 'Fecha de corte de cosecha', valor: solicitud.fechacortecosecha.substring(0, 10), idfc34_notificacionsuspencion: solicitud.idfc34_notificacionsuspencion,
        observaciones: JSON.stringify({}) !== JSON.stringify(fc_34Map) && JSON.stringify([]) !== JSON.stringify(fc_34Map) ? fc_34Map?.fechacortecosecha : '',
        correcto: JSON.stringify({}) !== JSON.stringify(fc_34Map) && JSON.stringify([]) !== JSON.stringify(fc_34Map) ? !fc_34Map?.fechacortecosechacheck : false,
        incorrecto: JSON.stringify({}) !== JSON.stringify(fc_34Map) && JSON.stringify([]) !== JSON.stringify(fc_34Map) ? fc_34Map?.fechacortecosechacheck : false,
    },
        {
            id: uuidv4(), Campo: 'Fecha de inicio de producción', valor: solicitud.fechainicioproduccion.substring(0, 10), idfc34_notificacionsuspencion: solicitud.idfc34_notificacionsuspencion,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_34Map) && JSON.stringify([]) !== JSON.stringify(fc_34Map) ? fc_34Map?.fechainicioproduccion : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_34Map) && JSON.stringify([]) !== JSON.stringify(fc_34Map) ? !fc_34Map?.fechainicioproduccioncheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_34Map) && JSON.stringify([]) !== JSON.stringify(fc_34Map) ? fc_34Map?.fechainicioproduccioncheck : false,
        },
        {
            id: uuidv4(), Campo: 'Especies de agave utilizado', valor: solicitud.especiesagaveutilizado, idfc34_notificacionsuspencion: solicitud.idfc34_notificacionsuspencion,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_34Map) && JSON.stringify([]) !== JSON.stringify(fc_34Map) ? fc_34Map?.especiesagaveutilizado : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_34Map) && JSON.stringify([]) !== JSON.stringify(fc_34Map) ? !fc_34Map?.especiesagaveutilizadocheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_34Map) && JSON.stringify([]) !== JSON.stringify(fc_34Map) ? fc_34Map?.especiesagaveutilizadocheck : false,
        },
        {
            id: uuidv4(), Campo: 'Fecha estimada de término de producción', valor: solicitud.fechaterminoproduccion.substring(0, 10), idfc34_notificacionsuspencion: solicitud.idfc34_notificacionsuspencion,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_34Map) && JSON.stringify([]) !== JSON.stringify(fc_34Map) ? fc_34Map?.fechaterminoproduccion : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_34Map) && JSON.stringify([]) !== JSON.stringify(fc_34Map) ? !fc_34Map?.fechaterminoproduccioncheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_34Map) && JSON.stringify([]) !== JSON.stringify(fc_34Map) ? fc_34Map?.fechaterminoproduccioncheck : false,
        },
        {
            id: uuidv4(), Campo: 'Número de lote', valor: solicitud.numerolote, idfc34_notificacionsuspencion: solicitud.idfc34_notificacionsuspencion,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_34Map) && JSON.stringify([]) !== JSON.stringify(fc_34Map) ? fc_34Map?.numerolote : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_34Map) && JSON.stringify([]) !== JSON.stringify(fc_34Map) ? !fc_34Map?.numerolotecheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_34Map) && JSON.stringify([]) !== JSON.stringify(fc_34Map) ? fc_34Map?.numerolotecheck : false,
        },
        {
            id: uuidv4(), Campo: 'Kg de agave', valor: solicitud.kgagave, idfc34_notificacionsuspencion: solicitud.idfc34_notificacionsuspencion,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_34Map) && JSON.stringify([]) !== JSON.stringify(fc_34Map) ? fc_34Map?.kgagave : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_34Map) && JSON.stringify([]) !== JSON.stringify(fc_34Map) ? !fc_34Map?.kgagavecheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_34Map) && JSON.stringify([]) !== JSON.stringify(fc_34Map) ? fc_34Map?.kgagavecheck : false,
        },
        {
            id: uuidv4(), Campo: 'Fecha de muestreo', valor: solicitud.fechamuestreo.substring(0, 10), idfc34_notificacionsuspencion: solicitud.idfc34_notificacionsuspencion,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_34Map) && JSON.stringify([]) !== JSON.stringify(fc_34Map) ? fc_34Map?.fechamuestreo : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_34Map) && JSON.stringify([]) !== JSON.stringify(fc_34Map) ? !fc_34Map?.fechamuestreocheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_34Map) && JSON.stringify([]) !== JSON.stringify(fc_34Map) ? fc_34Map?.fechamuestreocheck : false,
        },
        {
            id: uuidv4(), Campo: 'Información adicional sobre la actividad', valor: solicitud.informacionadicional, idfc34_notificacionsuspencion: solicitud.idfc34_notificacionsuspencion,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_34Map) && JSON.stringify([]) !== JSON.stringify(fc_34Map) ? fc_34Map?.informacionadicional : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_34Map) && JSON.stringify([]) !== JSON.stringify(fc_34Map) ? !fc_34Map?.informacionadicionalcheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_34Map) && JSON.stringify([]) !== JSON.stringify(fc_34Map) ? fc_34Map?.informacionadicionalcheck : false,
        },)
    let [rowspagina2, setRowsPagina2] = React.useState(pagina2)

    const handdleEditPrev = (objectProducto) => {
        const filtroGeneral = rowspagina1.findIndex(anexo => anexo.id === objectProducto.id)
        const filtroMotivo = rowspagina2.findIndex(anexo => anexo.id === objectProducto.id)
        if (filtroGeneral !== -1) {
            rowspagina1[filtroGeneral].valor = objectProducto.valor
            rowspagina1[filtroGeneral].correcto = objectProducto.correcto
            rowspagina1[filtroGeneral].incorrecto = objectProducto.incorrecto
            rowspagina1[filtroGeneral].observaciones = objectProducto.observaciones
        }
        if (filtroMotivo !== -1) {
            rowspagina2[filtroMotivo].valor = objectProducto.valor
            rowspagina2[filtroMotivo].correcto = objectProducto.correcto
            rowspagina2[filtroMotivo].incorrecto = objectProducto.incorrecto
            rowspagina2[filtroMotivo].observaciones = objectProducto.observaciones
        }
    }
    const botonRegresar = async () => {
        props.history.push('/AtencionAClientesComponent')
        await dispatch(resetDataFC_34())
    }
    const botonDevolverSolicitud = async () => {
        await dispatch(actualizarLoadingApp_true())
        if (JSON.stringify({}) === JSON.stringify(fc_34Map) || JSON.stringify([]) === JSON.stringify(fc_34Map) || fc_34Map === null) {
            await agregarMapYActualizarFC_34()
            const idSolicitud = solicitud.idfc34_notificacionsuspencion
            const estatusNuevo = 5
            const idCliente = null //Se necesita obtener del cliente, a traves del login 
            const tablaFC_34 = 8
            const tabla = tablaFC_34
            await dispatch(actualizarFC_34Estatus(
                { data: { tabla: tabla, idSolicitud: idSolicitud, estatus: estatusNuevo, idCliente: idCliente, folio: solicitud.folio } }
            ))
        } else {
            await actualizarMapYActualizarFC_34()
            const idSolicitud = solicitud.idfc34_notificacionsuspencion
            const estatusNuevo = 5
            const idCliente = null //Se necesita obtener del cliente, a traves del login 
            const tablaFC_34 = 8
            const tabla = tablaFC_34
            await dispatch(actualizarFC_34Estatus(
                { data: { tabla: tabla, idSolicitud: idSolicitud, estatus: estatusNuevo, idCliente: idCliente, folio: solicitud.folio } }
            ))
        }
        await dispatch(actualizarLoadingApp_false())
        props.history.push('/AtencionAClientesComponent')
    }
    const agregarMapYActualizarFC_34 = async () => {
        let principal = []
        const fechaHoy = moment().format('YYYY-MM-DD')
        let fechaSolicitudAceptada = new Date(fechaHoy).toISOString()
        principal.push({
            idfc34_notificacionsuspencion: solicitud.idfc34_notificacionsuspencion,
            fechasolicitud: fechaSolicitudAceptada
        })
        let datosPricipalMap = []
        datosPricipalMap.push({
            tipoinstalacion: rowspagina1[0].observaciones, tipoinstalacioncheck: rowspagina1[0].incorrecto,
            responsableinstalaciones: rowspagina1[1].observaciones, responsableinstalacionescheck: rowspagina1[1].incorrecto,
            correoelectronico: rowspagina1[2].observaciones, correoelectronicocheck: rowspagina1[2].incorrecto,
            telefono: rowspagina1[3].observaciones, telefonocheck: rowspagina1[3].incorrecto,
            domicilio: rowspagina1[4].observaciones, domiciliocheck: rowspagina1[4].incorrecto,
            certificadonomproductor: '', certificadonomproductorcheck: false,
            certificadonomcomercializador: '', certificadonomcomercializadorcheck: false
        })
        for (const dato of rowspagina1) {
            if (dato.Campo === 'Servicio de instalación a notificar: ') datosPricipalMap.push({ servicioinstalacion: dato.observaciones, servicioinstalacioncheck: dato.incorrecto })
            if (dato.Campo === 'Servicio de actividad a notificar: ') datosPricipalMap.push({ servicioactividad: dato.observaciones, servicioactividadcheck: dato.incorrecto })
        }
        for (const dato of rowspagina2) {
            if (dato.Campo === 'Motivo de la suspensión') datosPricipalMap.push({ motivosuspencion: dato.observaciones, motivosuspencioncheck: dato.incorrecto })
            if (dato.Campo === 'Fecha de corte de cosecha') datosPricipalMap.push({ fechacortecosecha: dato.observaciones, fechacortecosechacheck: dato.incorrecto })
            if (dato.Campo === 'Fecha de inicio de producción') datosPricipalMap.push({ fechainicioproduccion: dato.observaciones, fechainicioproduccioncheck: dato.incorrecto })
            if (dato.Campo === 'Especies de agave utilizado') datosPricipalMap.push({ especiesagaveutilizado: dato.observaciones, especiesagaveutilizadocheck: dato.incorrecto })
            if (dato.Campo === 'Fecha estimada de término de producción') datosPricipalMap.push({ fechaterminoproduccion: dato.observaciones, fechaterminoproduccioncheck: dato.incorrecto })
            if (dato.Campo === 'Número de lote') datosPricipalMap.push({ numerolote: dato.observaciones, numerolotecheck: dato.incorrecto })
            if (dato.Campo === 'Kg de agave') datosPricipalMap.push({ kgagave: dato.observaciones, kgagavecheck: dato.incorrecto })
            if (dato.Campo === 'Fecha de muestreo') datosPricipalMap.push({ fechamuestreo: dato.observaciones, fechamuestreocheck: dato.incorrecto })
            if (dato.Campo === 'Información adicional sobre la actividad') datosPricipalMap.push({ informacionadicional: dato.observaciones, informacionadicionalcheck: dato.incorrecto })
        }
        let obj_unidos = {}
        for (const i in datosPricipalMap) {
            obj_unidos = Object.assign(obj_unidos, datosPricipalMap[i])
        }
        obj_unidos.idfc34_notificacionsuspencion = solicitud.idfc34_notificacionsuspencion
        await dispatch(agregarMapFC_34Accion(obj_unidos))
        await dispatch(actualizarFC_34Solicitud(principal[0]))
        return
    }
    const actualizarMapYActualizarFC_34 = async () => {
        let principal = []
        const fechaHoy = moment().format('YYYY-MM-DD')
        let fechaSolicitudAceptada = new Date(fechaHoy).toISOString()
        principal.push({
            idfc34_notificacionsuspencion: solicitud.idfc34_notificacionsuspencion,
            fechasolicitud: fechaSolicitudAceptada
        })
        let datosPricipalMap = []
        datosPricipalMap.push({
            tipoinstalacion: rowspagina1[0].observaciones, tipoinstalacioncheck: rowspagina1[0].incorrecto,
            responsableinstalaciones: rowspagina1[1].observaciones, responsableinstalacionescheck: rowspagina1[1].incorrecto,
            correoelectronico: rowspagina1[2].observaciones, correoelectronicocheck: rowspagina1[2].incorrecto,
            telefono: rowspagina1[3].observaciones, telefonocheck: rowspagina1[3].incorrecto,
            domicilio: rowspagina1[4].observaciones, domiciliocheck: rowspagina1[4].incorrecto,
            certificadonomproductor: '', certificadonomproductorcheck: false,
            certificadonomcomercializador: '', certificadonomcomercializadorcheck: false
        })
        for (const dato of rowspagina1) {
            if (dato.Campo === 'Servicio de instalación a notificar: ') datosPricipalMap.push({ servicioinstalacion: dato.observaciones, servicioinstalacioncheck: dato.incorrecto })
            if (dato.Campo === 'Servicio de actividad a notificar: ') datosPricipalMap.push({ servicioactividad: dato.observaciones, servicioactividadcheck: dato.incorrecto })
        }
        for (const dato of rowspagina2) {
            if (dato.Campo === 'Motivo de la suspensión') datosPricipalMap.push({ motivosuspencion: dato.observaciones, motivosuspencioncheck: dato.incorrecto })
            if (dato.Campo === 'Fecha de corte de cosecha') datosPricipalMap.push({ fechacortecosecha: dato.observaciones, fechacortecosechacheck: dato.incorrecto })
            if (dato.Campo === 'Fecha de inicio de producción') datosPricipalMap.push({ fechainicioproduccion: dato.observaciones, fechainicioproduccioncheck: dato.incorrecto })
            if (dato.Campo === 'Especies de agave utilizado') datosPricipalMap.push({ especiesagaveutilizado: dato.observaciones, especiesagaveutilizadocheck: dato.incorrecto })
            if (dato.Campo === 'Fecha estimada de término de producción') datosPricipalMap.push({ fechaterminoproduccion: dato.observaciones, fechaterminoproduccioncheck: dato.incorrecto })
            if (dato.Campo === 'Número de lote') datosPricipalMap.push({ numerolote: dato.observaciones, numerolotecheck: dato.incorrecto })
            if (dato.Campo === 'Kg de agave') datosPricipalMap.push({ kgagave: dato.observaciones, kgagavecheck: dato.incorrecto })
            if (dato.Campo === 'Fecha de muestreo') datosPricipalMap.push({ fechamuestreo: dato.observaciones, fechamuestreocheck: dato.incorrecto })
            if (dato.Campo === 'Información adicional sobre la actividad') datosPricipalMap.push({ informacionadicional: dato.observaciones, informacionadicionalcheck: dato.incorrecto })
        }
        let obj_unidos = {}
        for (const i in datosPricipalMap) {
            obj_unidos = Object.assign(obj_unidos, datosPricipalMap[i])
        }
        obj_unidos.idfc34_notificacionsuspencion = solicitud.idfc34_notificacionsuspencion
        obj_unidos.idfc34_notificacionsuspencionmap = fc_34Map.idfc34_notificacionsuspencionmap
        await dispatch(actualizarFC_34MapSolicitud(obj_unidos))
        await dispatch(actualizarFC_34Solicitud(principal[0]))
        return
    }

    const [openModalAceptar, setOpenModalAceptar] = React.useState(false);
    const [dataModal, setDataModal] = React.useState('')
    const handleOpenModalAceptar = () => setOpenModalAceptar(true);
    const handleCloseModalAceptar = () => setOpenModalAceptar(false);
    const modalComponentAceptar = () => {
        return (
            <div>
                <Modal
                    open={openModalAceptar}
                    onClose={handleCloseModalAceptar}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={styleParaModalDeDocumentos}>
                        <Typography id="modal-modal-title" variant="h6" component="h2" color="black !important" align='center'>
                            Para finalizar el trámite ingrese los siguientes datos
                        </Typography>
                        <FormularioDocumentacionFC_34
                            functionAcept={botonAceptarSolicitud}
                        ></FormularioDocumentacionFC_34>
                        <br />

                        <br />
                    </Box>
                </Modal>
            </div>

        )
    }
    const botonAceptarSolicitud = async (dataForm) => {
        await dispatch(actualizarLoadingApp_true())
        if (JSON.stringify({}) === JSON.stringify(fc_34Map) || JSON.stringify([]) === JSON.stringify(fc_34Map) || fc_34Map === null) {
            await agregarMapYActualizarFC_34()
        } else {
            await actualizarMapYActualizarFC_34()
        }
        let resultado = await dispatch(obtenerFC_34SolicitudDetalle(solicitud.idfc34_notificacionsuspencion))
        const dataCliente = await dispatch(obtenerClienteByIdLogin(solicitud.idlogin))
        let dataMetricas = {
            estatus_procedencia: "Solicitudes Recibidas Procedentes",
            id_solicitud: "9", id_usuario: dataUser?.[0].idlogin,
            motivo: "Cargado automatico del sistema",
            fecha: moment().format('YYYY-MM-DD HH:mm:ss'),
            numero_cliente: solicitud?.numerocliente,
            numero_solicitud: dataForm?.numeroSolicitud, origen: "Sistema"
        }
        await dispatch(crearMetricas(dataMetricas))
        let informacionmodalaceptada = {
            numerosolicitudservicios: dataForm?.numeroSolicitud,
            numcertificadonom: dataForm?.numCertificadoNOM,
            fechainspeccion: dataForm?.fechaInspeccion,
            numplanevaluacion: dataForm?.numeroPlanEvaluacion,
            inspectorasignado: dataForm?.inspectorAsignado,
            credelcialinspector: dataForm?.credencialInspector,
            telefonoinspector: dataForm?.telefonoInspector
        }
        let actualizarinformacion = {
            idfc34_notificacionsuspencion: solicitud.idfc34_notificacionsuspencion,
            informacionmodalaceptada: informacionmodalaceptada
        }
        await dispatch(actualizarFC_34SolicitudModal(actualizarinformacion))

        await generarOficios(solicitud, dataCliente.payload.cliente[0], dataForm)
        const idSolicitud = solicitud.idfc34_notificacionsuspencion
        const estatusNuevo = 4
        const idCliente = null
        const tablaFC_34 = 8
        const tabla = tablaFC_34
        await dispatch(actualizarFC_34Estatus(
            { data: { tabla: tabla, idSolicitud: idSolicitud, estatus: estatusNuevo, idCliente: idCliente, folio: solicitud.folio } }
        ))
        const idRol = currentUser.user[0].rol
        if (idRol === 1) await dispatch(obtenerTodasLasSolicitudesWithStatusEnviado({ status: 4 }))
        else if (idRol === 2) await dispatch(obtenerTodasLasSolicitudesEjecuctivoWithStatusEnviado({ status: 4, revisor: dataUser[0]?.datoslogin.nombre + ' ' + dataUser[0]?.datoslogin.apellidos, idLogin: currentUser.user[0].id }))
        await dispatch(actualizarLoadingApp_false())
        props.history.push('/AtencionAClientesComponent')
    }
    const generarOficios = async (solicitudFC_34, dataCliente, dataForm) => {
        const data = {
            tipoSolicitud: 'FC_34',
            solicitudFC_34,
            dataCliente,
        }
        let servicio = ''
        if (solicitudFC_34.servicioactividad == 'suspension') servicio += 'SUSPENSIÓN DE '
        if (solicitudFC_34.servicioactividad == 'reactivacion') servicio += 'REACTIVACIÓN DE '

        if (solicitudFC_34.servicioinstalacion == 'produccion') servicio += 'PRODUCCIÓN'
        if (solicitudFC_34.servicioinstalacion == 'envasado') servicio += 'ENVASADO'
        if (solicitudFC_34.servicioinstalacion == 'almacen') servicio += 'ALMACÉN'


        const dataSolicitudInspeccion = {
            numeroSolicitud: dataForm.numeroSolicitud,
            numCertificadoNOM: dataForm.numCertificadoNOM,
            numeroTraslado: dataForm.numeroTraslado,
            otrosServicios: servicio,
            fechaInspeccion: dataForm.fechaInspeccion.substring(0, 10),
            numeroPlanEvaluacion: dataForm.numeroPlanEvaluacion,
            inspectorAsignado: dataForm.inspectorAsignado,
            credencialInspector: dataForm.credencialInspector,
            telefonoInspector: dataForm.telefonoInspector,
            checkFabrica: false,
            checkProductor: false,
            checkNacional: false,
            checkEnvasadora: false,
            checkEnvasador: false,
            checkExportacion: false,
            checkGranel: false,
            checkComercializador: false,
            checkPromocion: false,
            checkProductoTerminado: false,
            checkTraslado: false,
            checkMaduracion: false,
        }
        data.dataSolicitudInspeccion = dataSolicitudInspeccion
        await dispatch(generarDocumentosFC_34(data))
    }
    const [openModalDevolver, setOpenModalDevolver] = React.useState(false);
    const handleOpenModalDevolver = (params) => {
        setOpenModalDevolver(true)
    }
    const handleCloseModalDevolver = () => {
        setOpenModalDevolver(false)

    }
    const modalComponentDevolver = () => {
        return (
            <div>
                <Modal
                    open={openModalDevolver}
                    onClose={handleCloseModalDevolver}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                    hideBackdrop={true}
                >
                    <Box sx={styleDevolver}>

                        <Typography id="modal-modal-title" variant="h6" component="h2">
                            <center>¡Advertencia!</center>
                        </Typography>
                        <Typography id="modal-modal-description" component="h2" sx={{ mt: 2 }}>
                            <p>Está a punto de devolver esta solicitud.
                                Las observaciones serán enviadas al cliente para correcciones.</p>
                            <br /> <center><strong>¿Desea continuar?</strong></center>
                        </Typography>
                        <br />

                        <div className='row'>
                            <div className='col-md-6'>
                                <button className='btn btn-outline-success' onClick={() => { botonDevolverSolicitud() }}>CONTINUAR</button>
                            </div>
                            <div className={`${estilosFC34.botonCancelarModal} col-md-2`}>
                                <button className='btn btn-outline-danger' onClick={() => { handleCloseModalDevolver() }}>CANCELAR</button>
                            </div>
                        </div>

                    </Box>
                </Modal>
            </div>
        )
    }
    return (
        <Fragment>
            <div className='text-center'>
                <PaginacionAtencionAClientesComponent paginas={paginas} nombreParaPaginas={nombresParaPaginas} paginaActiva={paginaActiva} cambiarPagina={cambiarPagina} />
            </div>
            {nombresParaPaginas[paginaActiva - 1] === 'Datos solicitante' ?
                <div className='row justify-content-center'>
                    <div className='col-10'>
                        <TablaAtencionACliente rows={rowspagina1} api={{ handdleEditPrev }}></TablaAtencionACliente>
                    </div>
                </div> : nombresParaPaginas[paginaActiva - 1] === 'Suspención/Reactivación' ?
                    <div className='row justify-content-center'>
                        <div className='col-10'>
                            <TablaAtencionACliente rows={rowspagina2} api={{ handdleEditPrev }}></TablaAtencionACliente>
                        </div>
                        {modoVerDetalle ?
                            <div className="row text-center">
                                <div className='col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12'>
                                    <button type="submit" className={`btn ${estilosFC34.botonNaranjaRedondo}`} onClick={botonRegresar} >Regresar</button>
                                </div>
                            </div> :
                            <div className="row text-center mt-4 mb-4">
                                <div className='col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6'>
                                    <button type="submit" className={`btn ${estilosFC34.botonNaranjaRedondo}`} onClick={handleOpenModalAceptar}>Aceptar solicitud</button>
                                </div>

                                <div className='col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6'>
                                    <button type="submit" className={`btn ${estilosFC34.botonNaranjaRedondo}`} onClick={handleOpenModalDevolver}>Devolver solicitud</button>
                                </div>
                            </div>
                        }
                    </div> : ''
            }
            {modalComponentAceptar()}
            {modalComponentDevolver()}
        </Fragment>
    )
}

export default withRouter(FC_34Component)
